module.exports = __webpack_public_path__ + "static/media/Phone_Screenshots.6247fe9e.png";